import React from "react"

import { GatsbyImage } from "gatsby-plugin-image"
import PropTypes from "prop-types"

import * as styles from "./modal.module.scss"
import Button from "../../atoms/button"
import CopyContainer from "../../atoms/copy-container"
import Heading from "../../atoms/heading"
import Icon from "../../atoms/icon"

const Modal = ({
  closeModal,
  yesText,
  noText,
  yesEvent,
  yesUrl,
  message,
  image,
  person,
  title,
}) => (
  <div className={styles.modal}>
    <button
      type="button"
      aria-label="Close"
      onClick={closeModal}
      onKeyPress={closeModal}
      className={styles.close}
    >
      <Icon icon="close" />
    </button>
    {person ? (
      <div className={styles.modal__person}>
        {image ? (
          <div className={styles.left}>
            <GatsbyImage image={image} className={styles.person} alt={person} />
          </div>
        ) : (
          ""
        )}
        <div>
          <Heading level="3">{person}</Heading>
          <Heading level="5">{title}</Heading>
          <CopyContainer>{message}</CopyContainer>
        </div>
      </div>
    ) : (
      <>
        <div>{message}</div>
        {yesText || noText ? (
          <div className={styles.buttons}>
            {yesText ? (
              <Button pressEvent={yesEvent} url={yesUrl}>
                {yesText}
              </Button>
            ) : (
              ""
            )}
            {noText ? <Button pressEvent={closeModal}>{noText}</Button> : ""}
          </div>
        ) : (
          ""
        )}
      </>
    )}
  </div>
)

export default Modal

Modal.propTypes = {
  closeModal: PropTypes.func.isRequired,
  message: PropTypes.array.isRequired,
  yesText: PropTypes.string,
  noText: PropTypes.string,
  yesEvent: PropTypes.func,
  yesUrl: PropTypes.string,
  image: PropTypes.string,
  person: PropTypes.string,
  title: PropTypes.string,
}

Modal.defaultProps = {
  yesText: "",
  noText: "",
  yesEvent: null,
  yesUrl: "",
  image: "",
  person: "",
  title: "",
}
